import { ButtonComp } from 'atoms/Buttons';
import ImageComponent from 'atoms/Image/index';
import {
  getContactNowBtnText,
  getContactNumber,
  getHelpSectionCallDetails,
  getMessageDetails,
} from 'organisms/NeedHelp/Utils/NeedHelpUtils';
import { redirectToFaqPage } from 'common/utilities/utils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { isAddHopePurchase } from 'common/utilities/orderStatusUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

export const getHelpCallPanel = params => {
  const { contentData } = params;
  const { helpSectionCallDetails } = contentData;

  return (
    <div className='get-help-block mb-5'>
      <h3 className='header-text'>
        <span>{helpSectionCallDetails?.title}</span>
      </h3>
      <span className='section-text'>
        {isAddHopePurchase()
          ? translateWithI18Next(TRANSLATE_MAPPING_KEY?.ADD_HOPE_CUSTOMER_CARE)
          : getHelpSectionCallDetails(params)}
      </span>
      <div className='section-text mt-5 ContactUsButton call'>
        <a tabIndex='-1' href={'tel:' + getContactNumber(params)} className='anchorTags'>
          <ButtonComp
            ariaLable='contact us'
            data-testid='contact-us-btn'
            className='deepBlack font-bold button whiteButton blkBorder'
          >
            <ImageComponent srcFile={helpSectionCallDetails?.icon} alt=' ' className='Messageimage' />
            {getContactNowBtnText(params)}
          </ButtonComp>
        </a>
      </div>
    </div>
  );
};

export const getHelpMsgPanel = params => {
  const { contentData, isModalView } = params;
  const { helpSectionContactDetails } = contentData;

  return (
    <div className='get-help-block mb-5 get-msg-block'>
      <h3 className='header-text'>
        <span>{helpSectionContactDetails?.title}</span>
      </h3>
      <span className='section-text'>{helpSectionContactDetails?.description}</span>

      <div className='section-text mt-5 ContactUsButton'>
        <a
          tabIndex='-1'
          data-testid='anchor-test'
          onClick={event => {
            getMessageDetails(event, params);
          }}
          className='anchorTags'
        >
          <ButtonComp
            ariaLable='contact us'
            data-testid='contact-us-btn'
            className='deepBlack font-bold button whiteButton blkBorder'
          >
            <ImageComponent
              srcFile={
                helpSectionContactDetails?.icon ||
                (isModalView ? helpSectionContactDetails?.mobileIcon : helpSectionContactDetails?.desktopIcon)
              }
              alt=' '
              className='Messageimage'
            />
            {helpSectionContactDetails?.linkText || helpSectionContactDetails?.buttonText}
          </ButtonComp>
        </a>
      </div>
    </div>
  );
};

export const getFAQPanel = (params, history) => {
  const { contentData } = params;
  const { faqSectionDetails } = contentData;
  return (
    faqSectionDetails && (
      <div className='faq-survey-section mb-5'>
        <div class='faq-survey-block  m1-adjust'>
          <h3 className='header-text'>{faqSectionDetails?.title}</h3>
          <span className='section-text'>{faqSectionDetails?.description}</span>
          <div className='faq-text-block'>
            {faqSectionDetails?.topics?.map(item => {
              return (
                <a tabIndex='-1' className='anchorTags'>
                  <ButtonComp
                    onClick={() => redirectToFaqPage(history, item)}
                    ariaLable={item}
                    tabindex='0'
                    data-testid='topic-item'
                    className='section-text'
                  >
                    {item}
                  </ButtonComp>
                </a>
              );
            })}
          </div>
          <button
            className='section-text mt-5 deepBlack font-bold help-btn image-full-text-btn button whiteButton blkBorder view-all-faq-btn'
            onClick={() => redirectToFaqPage(history)}
            ariaLable='view all faq'
            data-testid='view-all-faq'
          >
            {faqSectionDetails?.btnText}
          </button>
        </div>
      </div>
    )
  );
};
